import { render } from "./alert_modal.vue?vue&type=template&id=1668dd5e"
import script from "./alert_modal.vue?vue&type=script&lang=js"
export * from "./alert_modal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__